import React, { useState, useRef, useEffect, useContext } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { Container, Grid, Table, Icon, Image, } from 'semantic-ui-react'
import "./GiftCardScreen.scss";
import atar_logo from "../../assets/home/atar_logo.png";
import ammzion from "../../assets/home/ammzion.png";
import dual_box from "../../assets/home/dual_box.png";
import calendar from "../../assets/home/calendar.png";
import valid from "../../assets/home/valid.png";
import gift from "../../assets/home/gift.png";
import { useTranslation } from "react-i18next";
import { StarButton } from '../../components'

const GiftCard = () => {
    const { t, i18n } = useTranslation();
    const history = useHistory();
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);
    return (
        <>
            <div className="container-fluid bg clearall">
                <div className="giftcardbg">
                    <NavLink
                        to="">
                        <img className="giftcar_logo" src={atar_logo} />
                    </NavLink>

                    <div className="ammzion_logo">
                        <img className="ammzion " src={ammzion} />
                    </div>
                    <div className="gift_area ">
                        <h4>{t("giftcard.titel")}</h4>
                        <p>{t("giftcard.para")}</p>
                    </div>
                    <div className="bit_sec">
                        <div className="bit">
                            <h5>{t("giftcard.box")}</h5>
                        </div>
                        <div className="bit_img">
                            <img className="dual_img" src={dual_box} />
                        </div>
                    </div>
                    <div className="calendar_sec">
                        <div className="claimed">
                            <img className="calendar_img" src={calendar} />
                            <div className="date_sec">
                                <h6> {t("giftcard.claimed")}</h6>
                                <h5>{t("giftcard.date")}</h5>
                            </div>
                            <div className="blanks"></div>
                        </div>
                        <div className="claimed">
                                <img className="calendar_img" src={valid} />
                                <div className="date_sec">
                                    <h6>{t("giftcard.valid")}</h6>
                                    <h5>{t("giftcard.validate")}</h5>
                                </div>
                                <div className="blanks"></div>
                            </div>
                            <div className="claimed">
                                <img className="calendar_img" src={gift} />
                                <div className="date_sec">
                                    <h6>{t("giftcard.value")}</h6>
                                    <h5>{t("giftcard.noumber")}</h5>
                                </div>
                                <div className="blanks"></div>
                            </div>
                    </div>
                    <div className=" claim_offer ">
                        <h3>{t("giftcard.claim")}</h3>
                        <ul>
                            <li>{t("giftcard.para1")}</li>
                            <li>{t("giftcard.para2")}</li>
                            <li>{t("giftcard.para3")}</li>
                            <li>{t("giftcard.para4")}</li>
                        </ul>
                    </div>
                    <div className="claim_offer">
                        <h3>{t("giftcard.terms")}</h3>
                        <ul>
                            <li>{t("giftcard.para1")}</li>
                            <li>{t("giftcard.para2")}</li>
                            <li>{t("giftcard.para3")}</li>
                            <li>{t("giftcard.para4")}</li>
                        </ul>
                    </div>
                    <div className=" claim_offer">
                        <h3>{t("giftcard.about")}</h3>
                        <ul>
                            <li>{t("giftcard.card")}</li>
                        </ul>
                    </div>
                    <div className="return_homepage ">
                        <StarButton background={'mainBg'} title={t("fourscreen.btn")} onClickAction={() => history.push('/')} />
                    </div>

                </div>
            </div>

        </>
    );
};

export default GiftCard